<div class="flex flex-col gap-y-2">
	<app-radio-group
		label="Select the mortgage priority"
		[items]="priorityOptions"
		type="compact"
		[ngModel]="value"
		(ngModelChange)="selectValue($event)"
		[testHook]="testHooks.SelectTheMortgagePriorityRadioGroup"
	></app-radio-group>
</div>
